/**
 * Como a mensagem chega, por canal: bolha do WhatsApp, e-mail na caixa de
 * entrada ou os tres blocos do roteiro de voz.
 *
 * E a MESMA peca no editor, no modal de previa, no historico e na
 * comparacao: o que a pessoa ve ao editar e exatamente o que vera depois de
 * salvar. Modelo com variavel posicional (`{{1}}`) ganha a legenda "{{1}} =
 * Primeiro nome" embaixo, porque a bolha sozinha nao diz o que entra ali.
 */

import { EmailPreview, WhatsAppPreview } from '../../../components/ui';
import type { CompanySummary } from '../../../types';
import type { MessageTemplate } from '../types';
import { variavelPorNome } from '../vocabulario';
import { RoteiroVoz } from './RoteiroVoz';

const REMETENTE_PADRAO = 'Converte Fácil';

/** Nome que aparece no topo do chat / no "De" do e-mail. */
export function remetenteDe(empresa: CompanySummary | null): string {
  return empresa === null ? REMETENTE_PADRAO : empresa.name;
}

export function remetenteEmailDe(empresa: CompanySummary | null): string {
  return empresa === null ? `${REMETENTE_PADRAO} <contato@convertefacil.exemplo>` : `${empresa.name} <contato@${empresa.slug}.exemplo>`;
}

function LegendaPosicional({ mapa }: { readonly mapa: readonly string[] }): JSX.Element | null {
  if (mapa.length === 0) {
    return null;
  }
  return (
    <p className="mt-2 flex flex-wrap gap-x-3 gap-y-1 text-[11px] text-ink-subtle">
      {mapa.map((nome, i) => (
        <span key={`${i}-${nome}`}>
          <span className="font-mono font-semibold text-brand">{`{{${i + 1}}}`}</span> = {nome === '' ? 'sem campo escolhido' : variavelPorNome(nome)?.label ?? nome}
        </span>
      ))}
    </p>
  );
}

export function PreviaDoCanal({ template, empresa, compacto = false }: { readonly template: MessageTemplate; readonly empresa: CompanySummary | null; readonly compacto?: boolean }): JSX.Element {
  switch (template.channel) {
    case 'whatsapp_oficial':
    case 'whatsapp_evolution':
      return (
        <div>
          <WhatsAppPreview
            from={remetenteDe(empresa)}
            body={template.body}
            footer={template.footer ?? undefined}
            buttons={template.channel === 'whatsapp_oficial' ? template.buttons.map((b) => ({ label: b.label, kind: b.kind })) : undefined}
          />
          <LegendaPosicional mapa={template.variableMap} />
        </div>
      );
    case 'email': {
      const cta = template.buttons[0];
      return (
        <EmailPreview
          from={remetenteEmailDe(empresa)}
          subject={template.subject ?? '(sem assunto)'}
          preheader={template.preheader}
          body={template.body}
          cta={cta === undefined || cta.label === '' ? undefined : cta.label}
        />
      );
    }
    case 'voice':
      return <RoteiroVoz script={template.voice ?? { opening: template.body, objection: '', closing: '' }} compacto={compacto} />;
  }
}
